import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';

import authTypes from '../../auth/types';
import actions from '../actions';

import { getTokensApi } from '../../api';

export function* getUserDataFlow() {
  yield put(
    actions.getTokensRequested(),
  );
  try {
    const {
      data: {
        totalMembers,
        totalAmountFinanced,
        totalPropertyValueFinanced,
        amountPaidOut,
        total1031InvestmentAmount,
        ...additionalTokens
      },
    } = yield call(getTokensApi, 'all');

    const tokens = {
      totalMembers: Number(totalMembers),
      totalAmountFinanced: Number(totalAmountFinanced),
      totalPropertyValueFinanced: Number(totalPropertyValueFinanced),
      amountPaidOut: Number(amountPaidOut),
      total1031InvestmentAmount: Number(total1031InvestmentAmount),
      ...additionalTokens,
    };

    yield put(
      actions.getTokensSucceeded(tokens),
    );
  } catch (error) {
    yield put(
      actions.getTokensFailed(error),
    );
  }
}

export function* watchAppInit() {
  yield takeLatest(
    authTypes.USER_SESSION_REQUESTED,
    getUserDataFlow,
  );
}

export default watchAppInit;
